var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6229 0C39.1035 0 37.8721 1.21393 37.8721 2.71175V13.5587C37.8721 17.0559 43.3742 17.0559 43.3742 13.5587V2.71175C43.3742 1.21393 42.1428 0 40.6229 0Z",
    fill: "url(#paint0_linear_72_474)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.058 6.31299C22.2861 3.28346 17.5221 5.99574 19.2935 9.02474L24.7951 18.4184C26.5708 21.4469 31.3358 18.7357 29.5596 15.7067L24.058 6.31299Z",
    fill: "url(#paint1_linear_72_474)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40414 23.648L15.9331 29.071C19.0074 30.8188 21.7582 26.122 18.6839 24.3742L9.15495 18.9512C6.08339 17.2007 3.33311 21.8981 6.40414 23.648Z",
    fill: "url(#paint2_linear_72_474)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4148 39.9539C16.4148 38.4571 15.1833 37.2421 13.6639 37.2427L2.66069 37.2432C-0.887433 37.2421 -0.886359 42.6656 2.66069 42.6667L13.6639 42.6656C15.1833 42.6656 16.4148 41.4528 16.4148 39.9539Z",
    fill: "url(#paint3_linear_72_474)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5996 51.8542C18.841 50.5576 20.3604 53.1518 19.5996 51.8542V51.8542Z",
    fill: "url(#paint4_linear_72_474)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 51.8533C18.8415 50.5568 17.1588 50.1119 15.8425 50.8608L6.31454 56.2843C3.23975 58.0321 5.9911 62.7278 9.06535 60.9822L18.5933 55.5576C19.9096 54.8087 20.3609 53.1509 19.6001 51.8533Z",
    fill: "url(#paint5_linear_72_474)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3951 60.5885C27.0799 59.8396 25.3972 60.2834 24.6375 61.5821L19.1369 70.9747C17.3613 74.0032 22.1258 76.7149 23.9014 73.6875L29.402 64.2939C30.1617 62.9952 29.7125 61.3374 28.3951 60.5885Z",
    fill: "url(#paint6_linear_72_474)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3931 60.5883C27.0779 59.8394 29.7105 61.3372 28.3931 60.5883V60.5883Z",
    fill: "url(#paint7_linear_72_474)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4392 63.8188C38.9209 63.8188 37.6884 65.0317 37.6895 66.5306V77.3765C37.6868 80.8753 43.1895 80.8743 43.1916 77.3776V66.5306C43.1905 65.0317 41.9613 63.8178 40.4392 63.8188Z",
    fill: "url(#paint8_linear_72_474)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4399 63.8193C38.9215 63.8193 41.9619 63.8183 40.4399 63.8193V63.8193Z",
    fill: "url(#paint9_linear_72_474)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2697 61.6706C54.4913 58.6432 49.7268 61.355 51.5052 64.3824L57.0057 73.776C58.7787 76.8056 63.5432 74.0938 61.7702 71.0643L56.2697 61.6706Z",
    fill: "url(#paint10_linear_72_474)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.658 56.4402L65.13 51.0167C62.0558 49.2699 59.3039 53.9668 62.3792 55.7135L71.9072 61.137C74.9793 62.888 77.729 58.1901 74.658 56.4402Z",
    fill: "url(#paint11_linear_72_474)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6602 19.4947C52.3346 19.3093 52.0187 19.1298 52.6709 19.5021C53.3188 19.8702 53.0072 19.6923 52.6827 19.5074C53.9947 20.2447 55.6699 19.8019 56.4275 18.5069L61.9291 9.11381C63.7053 6.08693 58.9397 3.37624 57.1646 6.4026L51.663 15.7952C50.9054 17.0907 51.3514 18.7395 52.6602 19.4947Z",
    fill: "url(#paint12_linear_72_474)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_474",
    x1: 40.6232,
    y1: 0,
    x2: 40.6232,
    y2: 16.1816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_72_474",
    x1: 24.4275,
    y1: 4.98926,
    x2: 24.4275,
    y2: 19.7417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_72_474",
    x1: 12.545,
    y1: 18.5669,
    x2: 12.545,
    y2: 29.4543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_72_474",
    x1: 8.20738,
    y1: 37.2427,
    x2: 8.20738,
    y2: 42.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_72_474",
    x1: 19.6002,
    y1: 51.48,
    x2: 19.6002,
    y2: 52.2289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_72_474",
    x1: 12.4702,
    y1: 50.4971,
    x2: 12.4702,
    y2: 61.3647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_72_474",
    x1: 24.2592,
    y1: 60.2246,
    x2: 24.2592,
    y2: 75.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_72_474",
    x1: 28.3937,
    y1: 60.3721,
    x2: 28.3937,
    y2: 60.8045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_72_474",
    x1: 40.4405,
    y1: 63.8188,
    x2: 40.4405,
    y2: 80.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_72_474",
    x1: 40.4408,
    y1: 63.8188,
    x2: 40.4408,
    y2: 63.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_72_474",
    x1: 56.6367,
    y1: 60.3481,
    x2: 56.6367,
    y2: 75.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_72_474",
    x1: 68.5174,
    y1: 50.6338,
    x2: 68.5174,
    y2: 61.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_72_474",
    x1: 56.8065,
    y1: 5.08057,
    x2: 56.8065,
    y2: 19.8636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#245F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B8E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLoader);
export default __webpack_public_path__ + "static/media/new-loader.4362a82d9500c9f97b736a48bf9455ce.svg";
export { ForwardRef as ReactComponent };